import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';

import {MapService} from '../../services/map/map.service';

/**
 * Creates the back button on the top left of the esri-ui that allows the user to go back to previous locations
 */
@Component({
  selector: 'app-previous-extent',
  templateUrl: './previous-extent.component.html',
  styleUrls: ['./previous-extent.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PreviousExtentComponent implements OnInit {

  constructor(private map: MapService) { }

  ngOnInit() {}

  /**
   * Controls tool click action. Decrements the extent index tracker and zooms to previous extent
   */
  public onClick() {
    const extentAr = this.map.getExtentAr();
    const extentIndex = this.map.getExtentIndex();
    if (extentAr[extentIndex - 1]) {
      this.map.holdZoomTrue();
      this.map.getViewRef().goTo({
        target:  extentAr[extentIndex - 1],
        heading: 0,
      });
      this.map.setExtentIndex(this.map.getExtentIndex() - 1);
    }

  }

}
